import { render, staticRenderFns } from "./SharedMediaAdd.vue?vue&type=template&id=38564495&"
import script from "./SharedMediaAdd.vue?vue&type=script&lang=js&"
export * from "./SharedMediaAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports